import React from "react";
import "../section-header/styles.css";
import Text from "../typography/text.js";

const SectionHeader = ({
  title,
  buttonLabel,
  onButtonClick,
  showButton = true,
  rightContent,
  style,
}) => {
  return (
    <div className="section-header-wrapper" style={style}>
      <Text variant="bodyText" color="darkText">
        {title}
      </Text>
      {rightContent
        ? rightContent
        : showButton &&
          buttonLabel && (
            <button className="section-header-button" onClick={onButtonClick}>
              + {buttonLabel}
            </button>
          )}
    </div>
  );
};

export default SectionHeader;
